import {
  ChartSquareBarIcon,
  DocumentAddIcon,
  LinkIcon,
  PencilAltIcon,
  PresentationChartLineIcon,
} from "@heroicons/react/outline";
import { ArtifactActivityType } from "types/graphql-schema";

import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

const ActivityIcon = ({
  activityType,
}: {
  activityType: ArtifactActivityType;
}) => {
  if (activityType === ArtifactActivityType.ArtifactCreation) {
    return <DocumentAddIcon className="h-4 w-4 text-gray-500" />;
  } else if (
    activityType === ArtifactActivityType.KeyResultAdded ||
    activityType === ArtifactActivityType.KeyResultRemoved ||
    activityType === ArtifactActivityType.KeyResultUpdated
  ) {
    return <ChartSquareBarIcon className="h-4 w-4 text-gray-500" />;
  } else if (activityType === ArtifactActivityType.ArtifactUpdate) {
    return <PencilAltIcon className="h-4 w-4 text-gray-500" />;
  } else if (
    activityType === ArtifactActivityType.ReferencedFromTopic ||
    activityType === ArtifactActivityType.ReferencedFromArtifact
  ) {
    return <TopicflowIcon type="meeting" className="h-4 w-4 text-gray-500" />;
  } else if (
    activityType === ArtifactActivityType.GoalCheckin ||
    activityType === ArtifactActivityType.CommentAdded
  ) {
    return <PresentationChartLineIcon className="h-4 w-4 text-gray-500" />;
  } else if (
    activityType === ArtifactActivityType.CompetencyConnected ||
    activityType === ArtifactActivityType.CompetencyDisconnected
  ) {
    return <LinkIcon className="h-4 w-4 text-gray-500" />;
  } else {
    throw new Error(`activityType not handled: ${activityType}`);
  }
};

export default ActivityIcon;
